import { useState } from 'react';
import { addToast } from '@heroui/toast';
import { clearAdminCache } from '@/api/adminApi';
import { btnAccent, card, input, label } from '@/components/ui/design';

const PRESETS = ['event:', 'ORGANIZERS_INFO_CACHE'];

export default function CacheTab() {
    const [prefix, setPrefix] = useState('');
    const [busy, setBusy] = useState(false);

    const clear = async () => {
        const target = prefix.trim();
        const message = target ? `Clear all cache keys starting with "${target}"?` : 'Clear the ENTIRE Redis cache? Every cached page will be rebuilt on demand.';
        if (!window.confirm(message)) return;
        setBusy(true);
        try {
            const result = await clearAdminCache(target);
            addToast({ title: 'Cache cleared', description: result.cleared === 'all' ? 'Entire cache flushed.' : `${result.cleared} keys removed.`, color: 'success' });
        } catch (error: any) {
            addToast({ title: 'Could not clear cache', description: error?.response?.data?.message || error?.message || 'Please try again.', color: 'danger' });
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className={`${card} max-w-xl p-6`}>
            <h2 className="mb-1 text-xl font-bold tracking-[-0.02em] text-grey10 dark:text-white">Redis cache</h2>
            <p className="mb-5 text-sm text-grey40 dark:text-nightMuted">Leave the prefix empty to flush everything, or enter a key prefix to remove only matching keys.</p>
            <label className="block">
                <span className={label}>Key prefix (optional)</span>
                <input value={prefix} onChange={e => setPrefix(e.target.value)} placeholder="e.g. event:" className={input} />
            </label>
            <div className="mt-3 flex flex-wrap gap-2">
                {PRESETS.map(preset => (
                    <button key={preset} type="button" onClick={() => setPrefix(preset)} className="rounded-full bg-grey99 px-3 py-1 text-xs font-semibold text-grey30 hover:bg-grey95 dark:bg-white/[0.06] dark:text-nightTextSecondary">{preset}</button>
                ))}
            </div>
            <button type="button" onClick={clear} disabled={busy} className={`${btnAccent} mt-5`}>{busy ? 'Clearing...' : prefix.trim() ? 'Clear matching keys' : 'Clear entire cache'}</button>
        </div>
    );
}
